module.exports = "/_next/static/images/2e4e939becebf234e23997514066e5fe-nu-icon.png.webp";